import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'YellowJacket',
		primary: {
			main: '#FFC502',
			contrast: '#ffffff',
			hover: '#393939',
			pressed: '#FFC502',
		},
		spacing: 8,
	},
};

export const YellowJacketTheme = merge({}, WrenchTheme, changes);
